// extracted by mini-css-extract-plugin
export default {"spacing":"n3Mir"};